import React from "react";

export const removeAccents = (str) => {
  // Remplacer les caractères accentués par leurs équivalents non accentués
  return str
    .normalize("NFD")  // Normaliser les caractères accentués en caractères de base et accents séparés
    .replace(/[\u0300-\u036f]/g, ""); // Supprimer les accents (caractères diacritiques)
}